var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgZimbabwe(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_27735_107051)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16 32C24.8366 32 32 24.8366 32 16C32 7.16344 24.8366 0 16 0C7.16344 0 0 7.16344 0 16C0 24.8366 7.16344 32 16 32Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.4686 9.16246C29.6557 7.44534 28.5462 5.8964 27.2062 4.58109L16 3.47803L4.79374 4.58115C4.75799 4.61621 4.72312 4.65209 4.68774 4.68753L9.16274 9.16253L16 9.37134L30.4686 9.16246Z",
    fill: "#FFDA44"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.6875 27.3123C4.74637 27.3712 4.80512 27.4301 4.86487 27.4881L15.9999 28.5216L27.1349 27.4881C28.4887 26.1756 29.6117 24.6266 30.436 22.9067L9.739 22.2607C7.95819 24.0416 5.90419 26.0955 4.6875 27.3123V27.3123Z",
    fill: "#FFDA44"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.8408 13.744L13.2173 13.2173L15.9999 15.9999C15.1757 16.8241 13.9453 18.0545 13.2173 18.7825L31.831 18.3254C31.9417 17.5661 31.9999 16.7898 31.9999 15.9999C31.9999 15.234 31.9449 14.4812 31.8408 13.744V13.744Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16 0C11.6357 0 7.68033 1.74813 4.7937 4.58138H27.2062C24.3196 1.74813 20.3642 0 16 0Z",
    fill: "#6DA544"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.744 13.744H31.8408C31.6125 12.1265 31.1427 10.5869 30.4685 9.1626H9.1626L13.744 13.744Z",
    fill: "#D80027"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.09302 22.9066H30.436C31.1181 21.4833 31.5954 19.9435 31.8311 18.3252H13.6744C11.9002 20.0994 10.3966 21.603 9.09302 22.9066Z",
    fill: "#D80027"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.9999 32.0001C20.3284 32.0001 24.2546 30.2806 27.1349 27.4883H4.86499C7.74524 30.2806 11.6715 32.0001 15.9999 32.0001Z",
    fill: "#6DA544"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.71347 3.74609C5.35778 4.04497 5.01459 4.35828 4.68628 4.68647L16 16.0002L4.68628 27.314C5.01453 27.6422 5.35778 27.9555 5.71347 28.2543L17.9676 16.0002L5.71347 3.74609Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.43281 11.8262L7.46875 15.0147H10.8216L8.10919 16.9854L9.14519 20.174L6.43281 18.2034L3.72038 20.174L4.7565 16.9854L2.04419 15.0147H5.39681L6.43281 11.8262Z",
    fill: "#D80027"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.28238 16.2611L6.5825 15.3046C6.5825 15.3046 6.383 13.4332 6.37094 13.3697C6.27931 12.887 5.85513 12.522 5.34575 12.522C4.7695 12.522 4.30225 12.9892 4.30225 13.5655C4.30225 13.661 4.31619 13.7531 4.34025 13.8411L3.58325 14.6032H4.92925C4.92925 16.0002 3.88675 16.0002 3.88675 17.3915L4.46506 18.7828H7.94331L8.52306 17.3915H8.52281C8.58088 17.258 8.61613 17.1203 8.63069 16.9828C9.13044 16.7807 9.28238 16.2611 9.28238 16.2611V16.2611Z",
    fill: "#FFDA44"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_27735_107051"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgZimbabwe);
export default __webpack_public_path__ + "static/media/zimbabwe.4ceab9a5e00124c5ecc8e3e415d0acb8.svg";
export { ForwardRef as ReactComponent };